import React from "react";
import DownloadCsvButton from "@components/FlowActionButtons/DownloadCsvButton";
import type { VendorLicenseTask, VendorLicenseTaskDecision } from "@services/licensing/types";
import { useDownloadLicenseCsv } from "./hooks";

type LicenseFlowData = {
  id: string;
  status: string;
  task: VendorLicenseTask | null;
  taskDecision?: VendorLicenseTaskDecision | null;
};

interface DownloadCsvProps {
  licenseFlowData?: LicenseFlowData;
  onDownloadCsv?: () => void;
}

const LANG_BASE = "licensing";

const DownloadCsv: React.FC<DownloadCsvProps> = ({ licenseFlowData, onDownloadCsv }) => {
  const { onDownloadLicenseCsv } = useDownloadLicenseCsv(licenseFlowData?.id);

  const isActionAvailable = Boolean(
    licenseFlowData?.task?.status === "COMPLETED" &&
      licenseFlowData?.taskDecision?.status === "APPROVED",
  );

  const handleDownload = () => {
    onDownloadCsv?.();
    onDownloadLicenseCsv();
  };

  return (
    <DownloadCsvButton
      langBase={LANG_BASE}
      permission="canDownloadVendorLicenseCsv"
      isActionAvailable={isActionAvailable}
      onDownloadCsv={handleDownload}
    />
  );
};

export default DownloadCsv;
